import styled, { css } from 'styled-components';
import { IconInfoProps } from './IconInfo';

interface ContainerProps {
	$variant: IconInfoProps['variant'];
	value?: string;
}

export const Icon = styled.div`
	width: 16px;
	height: 16px;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.primary.medium};
`;

export const Info = styled.div`
	display: flex;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.body.light};
`;

export const Category = styled.div``;

export const Value = styled.div``;

export const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
	gap: 4px;

	${({ $variant, value }) =>
		$variant === 'large' &&
		css`
			align-items: ${value ? 'start' : 'center'};
			gap: 8px;

			${Icon} {
				width: 24px;
				height: 24px;
				font-size: 24px;
			}

			${Info} {
				flex-direction: column;
				font-size: 16px;
				gap: ${value ? '4px' : '0'};
			}

			${Value} {
				color: ${({ theme }) => theme.colors.body.medium};
				font-weight: 600;
			}
		`}
`;
